$(document).on('turbolinks:load', function(){
  $(".blog-search").on("keyup", function() {
    var value = $(this).val().toLowerCase();
    var $modalContent = $(this).closest(".modal-content");
    $modalContent.find(".blog-list .custom-control").filter(function() {
      $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    });
  });

  $(".vlog-search").on("keyup", function() {
    var value = $(this).val().toLowerCase();
    var $modalContent = $(this).closest(".modal-content");
    $modalContent.find(".vlog-list .custom-control").filter(function() {
      $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    });
  });

  $(document).on('show.bs.modal', '.edit-url-blogs-modal, .edit-url-vlogs-modal', function (e) {
    $('.edit-url-buttons-modal').modal('hide');
  });

  $(document).on('submit', '#another-website-form', function(e){
     e.preventDefault();
     e.stopPropagation();
     var modalId = $(this).attr('data-id');
     $('#url_'+modalId).val($('#edit_url_'+modalId).val());
     $('#title_'+modalId).val('');
     $('#author_'+modalId).val('');
     $('#content_type_'+modalId).val('Link');
    //  $('#content_type_'+modalId+' option[value="Link"]').prop('selected', true);
     setTimeout(function(){
       $('.link-select-modal').modal('hide');
       toastr.options = {
         "preventDuplicates": true,
         "preventOpenDuplicates": true
       };
       toastr.info('Content form updated. Complete the form and click save.');
     }, 300);
  });

  $(document).on('change', '.card-link-file-input', function(e){
    var reader = new FileReader();
    var el = $(this);
    reader.onload = function (e) {
      $(el.attr('data-target')).attr('src', e.target.result);
    }
    reader.readAsDataURL(el[0].files[0]);
  });
  
});